import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Heading, Text, Stack, Badge, Flex, Divider, Button } from '@chakra-ui/react';
import { useCombinedStore } from '../../../store/hooks/useCombinedStore';

const BusDetail = () => {
    const { id } = useParams<{ id: string; }>();
    const { buses } = useCombinedStore();
    const bus = buses.find(b => b._id === id);
    const cardsBorderRadii = "8px";

    if (!bus) return <Text>Bus not found</Text>;

    return (
        <Box maxW="700px" mx="auto" p={6} bg="white" borderRadius={cardsBorderRadii} boxShadow="md">
            <Flex justify="space-between" align="center" mb={4}>
                <Heading size="lg">{bus.company}</Heading>
                <Badge colorScheme="blue" fontSize="sm">Bus #{bus._id}</Badge>
            </Flex>

            <Stack spacing={3}>
                <Flex justify="space-between">
                    <Text fontWeight="bold">From:</Text> <Text>{bus.from}</Text>
                    <Text fontWeight="bold">To:</Text> <Text>{bus.to}</Text>
                </Flex>

                <Flex justify="space-between">
                    <Text fontWeight="bold">Departure:</Text> <Text>{bus.departureTime || 'N/A'}</Text>
                    <Text fontWeight="bold">Arrival:</Text> <Text>{bus.arrivalTime || 'N/A'}</Text>
                </Flex>

                <Divider />

                <Text fontWeight="bold">Price:</Text>
                <Text fontSize="xl" color="green.600">${bus.price || 'N/A'}</Text>

                <Button colorScheme="blue" mt={4}>Book Now</Button>
            </Stack>
        </Box>
    );
};

export default BusDetail;
